import PlusIcon from 'mdi-react/PlusIcon'
import { reduxForm } from 'redux-form'
import { MuiClasses } from '../../types'
import { ReduxForm } from '../../types/forms'
import SubmitFormButton from '../Buttons/SubmitFormButton'

interface FormContainerProps extends ReduxForm {
  classes: MuiClasses
  submitAction: (arg?: any) => void
  children: any
  submitButton?: boolean
  buttonLabel?: string
  anyTouched: boolean
  customClasses?: any
}

const FormContainer = ({
  handleSubmit,
  submitAction,
  children,
  submitButton,
  anyTouched,
  buttonLabel,
  submitting,
  customClasses
}: FormContainerProps) => (
  <form onSubmit={handleSubmit(submitAction)}>
    {children}
    {submitButton && (
      <SubmitFormButton
        customClasses={customClasses}
        submitting={submitting}
        disabled={anyTouched} // workaround for lack of submitting progress, maybe add better handling later?
        label={buttonLabel}
        icon={PlusIcon}
      />
    )}
  </form>
)

export default reduxForm({})(FormContainer as any) as any
